import React from 'react';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

const QuestionSet = (props) => {
    const {data, updateSetData, removeQuestionFromSet, toggleQuestionSearch, newSet} = props;
    return (
        <div style={styles['form']}>
            <TextField
                value={data.id} 
                onChange={(e)=>updateSetData(e.target.value, "id")}
                label="ID"
                style={{ margin: 5 }}
                multiline
                rowsMax={5}
                disabled={!newSet}
            />
            <TextField
                value={data.description}
                onChange={(e)=>updateSetData(e.target.value, "description")}
                label="Description"
                style={{ margin: 5 }}
                multiline
                rowsMax={5}
            />
            <h4>Fields</h4>
            {data.fields.map((field, idx) => {
                return (
                    <div key={field} style={{width: '50%', position: 'relative'}}>
                        <p>{field} </p>
                        <IconButton style={{ position: 'absolute', right: 20, top: 0 }} onClick={()=>removeQuestionFromSet(idx)}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </div>
                )
            })}
            <button style={styles['button']} onClick={toggleQuestionSearch}>
                Add New Field
            </button>
        </div>
    )
};

const styles = {
    form: {
        display: 'flex',
        flexDirection: 'column',
        width: '80%',
    },
    'button': {
        backgroundColor: '#f0a34e',
        color: 'white',
        cursor: 'pointer',
        borderRadius: 8,
        fontSize: 12,
        padding: 8,
        margin: 10,
        width: '50%',
    }
}

export default QuestionSet;